









































import { ButtonType } from '@getaccept/lib-ui';
import type {
  PricingTableSection as IPricingTableSection,
  PricingTableCurrencySettings,
  MergeValues,
  Field,
} from '@getaccept/editor-lib';
import {
  Context,
  NumberInputType,
  ValueAlign,
  getColumns,
  PricingTableHelper,
  getGridTemplateColumns,
  getRowsSortedByColumnOrder,
  getSectionHeader,
  getSectionSummary,
} from '@getaccept/editor-lib';
import type { EditorRecipientInput } from '@getaccept/lib-shared/src/types/editor-recipient-input';
import type { Recipient } from '@getaccept/lib-shared/src/types/Recipient';
import type { PropType } from '@vue/composition-api';
import { defineComponent, ref } from '@vue/composition-api';
import PricingTableColumnHeaders from './PricingTableColumnHeaders.vue';
import PricingTableRow from './PricingTableRow.vue';
import PricingTableSectionSummary from './PricingTableSectionSummary.vue';

export default defineComponent({
  name: 'PricingTableSection',
  components: {
    PricingTableColumnHeaders,
    PricingTableRow,
    PricingTableSectionSummary,
  },
  props: {
    sections: { type: Array as PropType<IPricingTableSection[]>, default: () => [] },
    sectionId: { type: String, default: '' },
    currencySettings: {
      type: Object as PropType<PricingTableCurrencySettings>,
      default: () => ({}),
    },
    isPreCalculated: { type: Boolean },
    mergeValues: { type: Object as PropType<MergeValues>, default: () => ({}) },
    fields: { type: Array as PropType<Field[]>, default: () => [] },
    context: { type: String as PropType<Context>, default: () => Context.DocumentView },
    isBlockWidthSmall: { type: Boolean },
    recipientInput: { type: Array as PropType<EditorRecipientInput[]>, default: () => [] },
    recipient: { type: Object as PropType<Recipient>, default: () => ({}) },
  },
  setup() {
    const showAddMenu = ref(false);

    return {
      getEnabledColumns: PricingTableHelper.getEnabledColumns,
      showAddMenu,
      ValueAlign,
      NumberInputType,
      ButtonType,
      getColumns,
      getGridTemplateColumns,
      getRowsSortedByColumnOrder,
      getSectionSummary,
      getSectionHeader,
    };
  },
});
